import { Button, Stack } from '@mui/material'
import { useTheme } from '@mui/system'

import { ChevronRight } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'

import { postClientConfiguredCta } from '../../../../common/utils/PostMessage'

import { Beat } from '../../../types/CommonBeat'

const ClientConfigurableCta = ({ beat }: { beat: Beat }) => {
  const theme = useTheme()

  if (!beat.in_description_cta && !beat.html_in_description_cta) return <></>

  return (
    <Stack sx={{ alignItems: 'start', justifyContent: 'center', minHeight: 28, mt: 6 }}>
      <Button
        endIcon={<ChevronRight />}
        onClick={() => postClientConfiguredCta(beat.template)}
        size="small"
        sx={{
          '&.MuiButtonBase-root': {
            p: 4,
          },
          //the overrides are due to some other unfortunate overrides in pulse that make this the secondary color :(
          '&.MuiButton-root': {
            color: `${theme.palette.primary.main} !important`,
          },
          '&.MuiButton-root:hover': {
            color: `${theme.palette.primary.main} !important`,
          },
        }}
        variant="text"
      >
        <Text bold={true} variant="body2">
          {beat.in_description_cta || beat.html_in_description_cta}
        </Text>
      </Button>
    </Stack>
  )
}

export default ClientConfigurableCta
